import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { htm002Options, otherDeductionsDetailInputList3 } from '../../../../common/data';

import ItemTitleSection from '../../../../components/ItemTitleSection';
import Button from '../../../../components/common/Button';
import DetailButtonSection from '../../../../components/DetailButtonSection';
import DetailTitleSection from '../../../../components/DetailTitleSection';
import {
  handleAddButton,
  handleChange,
  handleDeleteButton,
  isValidate03,
  renderField,
} from '../util';
import {
  deleteOtherDeductionsData,
  getOtherDeductionsData3,
  saveOtherDeductionsData,
} from '../otherDeductionsSlice';
import SlideRightDialog from '../../../../components/common/SlideRightDialog';
import { getAlertMessageFunction, magamCertifyCheck } from '../../../../common/Util';

// 투자조합
const Type3 = ({ isOpen, onClose }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation('deductions/other');
  const { t: tCommon } = useTranslation('common');
  const { s11_3Data, detailReload } = useSelector(state => state.otherDeductions);
  const { isMagam, isCertify } = useSelector(state => state.common);
  const inputFields = otherDeductionsDetailInputList3(t);

  const [dataList, setDataList] = useState([]);
  const initData = {
    htmFlag: 'I',
    htmKFlag: '2',
    htm003: '',
    htm004: '',
    htm007: '',
    htm008: '',
    htm009: '',
    htmSeq: '',
  };

  useEffect(() => {
    //초기는 메인에서 받는다. 삭제, 저장할때만 다시받음
    if (detailReload != -1) {
      dispatch(getOtherDeductionsData3());
    }
  }, [detailReload]);

  useEffect(() => {
    if (isOpen) {
      const formattedData = s11_3Data?.map(item => {
        return {
          htmFlag: item.htmFlag?.trim(),
          htmKFlag: item.htmKFlag,
          htmPDFFlag: item.htmPDFFlag || '',
          htmType: item.htmType || '',
          htm003: item.htm003,
          htm004: item.htm004,
          htm007: item.htm007,
          htm008: item.htm008,
          htm009: item.htm009,
          htmSeq: item.htmSeq,
        };
      });
      setDataList(formattedData);
    }
  }, [s11_3Data, isOpen]);

  const handleSave = async () => {
    if (!magamCertifyCheck(isMagam, isCertify)) {
      return;
    }

    if (!isValidate03(dataList, t)) {
      return;
    }

    const alertMessage = getAlertMessageFunction();
    let formData = [...dataList];
    try {
      const resultAction = await dispatch(saveOtherDeductionsData({ formData })).unwrap();

      if (resultAction.resultCode === 'OK') {
        alertMessage(tCommon('alertMessage.saveSuccess'), 'success');
        onClose();
      } else {
        alertMessage(tCommon('alertMessage.saveFail'), 'error');
      }
    } catch (error) {
      alertMessage(tCommon('alertMessage.saveFail'), 'error');
      console.error('저장 중 오류 발생: ', error);
    }
  };

  return (
    <SlideRightDialog isOpen={isOpen} onClose={onClose}>
      <div className="displayFlexColumn" style={{ gap: '24px' }}>
        <DetailTitleSection title={`${t('detail.type3.title')}`} />
        {dataList.map((data, index) => {
          //국세청자료
          let disabled = data?.htmType == '1' && data?.htmPDFFlag == '2' && data?.htmKFlag == '1';
          return (
            <div key={index} className="displayFlexColumn" style={{ gap: '10px' }}>
              <ItemTitleSection
                title={`${t('detail.type3.title')}${index + 1}`}
                buttonIcon={!disabled}
                handleDeleteButton={() => {
                  if (!magamCertifyCheck(isMagam, isCertify)) {
                    return;
                  }
                  handleDeleteButton(index, setDataList, tCommon, dispatch, dataList, 'I');
                }}
              />

              <div className="displayFlexColumn" style={{ gap: '16px' }}>
                {inputFields.map((field, idx) => (
                  <div key={idx}>
                    {renderField(
                      field,
                      data[field.key],
                      value => handleChange(index, field.key, value, setDataList, dispatch),
                      disabled,
                    )}
                  </div>
                ))}
              </div>
            </div>
          );
        })}

        <Button
          value={t('detail.type3.addButton')}
          style={{ width: '100%' }}
          addButton
          color="sub"
          onClick={() => {
            if (!magamCertifyCheck(isMagam, isCertify)) {
              return;
            }
            handleAddButton(setDataList, initData);
          }}
        />

        <DetailButtonSection onSave={handleSave} onClose={onClose} />
      </div>
    </SlideRightDialog>
  );
};

export default Type3;
